module.exports = __webpack_public_path__ + "img/boho_rio_gift_crown.0642d6f1.svg";